// Reliable Accordion Toggle
document.addEventListener('DOMContentLoaded', function() {
  // Select all toggle buttons
  var toggleButtons = document.querySelectorAll('.details-toggle');
  
  toggleButtons.forEach(function(button) {
    button.onclick = function() {
      // Find the content element (next sibling)
      var content = this.nextElementSibling;
      
      // Find the toggle icon
      var icon = this.querySelector('.toggle-icon');
      
      // Toggle content visibility
      if (content.classList.contains('active')) {
        content.classList.remove('active');
        content.style.display = 'none';
        if (icon) icon.classList.remove('active');
      } else {
        content.classList.add('active');
        content.style.display = 'block';
        if (icon) icon.classList.add('active');
      }
    };
  });
});